import Skeleton from '@/common/components/Skeleton';

const BranchDataLoadingState = () => {
  return (
    <div className="w-[216px] p-4 flex flex-col gap-2">
      <div className='flex items-center gap-2'>
        <Skeleton circle />

        <Skeleton width={80} />
      </div>

      <div className='flex flex-col gap-2'>
        <div className='flex items-center gap-1'>
          <Skeleton width={80} />

          <Skeleton width={60} />
        </div>

        <div className='flex items-center gap-1'>
          <Skeleton width={80} />

          <Skeleton width={60} />
        </div>

        <div className='flex items-center gap-1'>
          <Skeleton width={80} />

          <Skeleton width={60} />
        </div>
      </div>

      <div className='flex items-center gap-1'>
        <Skeleton width={80} />

        <Skeleton width={24} />
      </div>

      <div className='flex items-center gap-1'>
        <Skeleton width={80} />

        <Skeleton width={24} />
      </div>

      <Skeleton width={120} />
    </div>
  )
}

export default BranchDataLoadingState;
